import {Component, NgModule} from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';


@Component({
  selector: 'app-features-landing',
  templateUrl: './features-landing.html',
  styleUrls: ['./features-landing.scss']
})
export class FeaturesLanding {
}

@NgModule({
  imports: [ MatIconModule, MatButtonModule, MatToolbarModule ],
  exports: [FeaturesLanding],
  declarations: [FeaturesLanding],
})
export class FeaturesLandingModule {}